import clsx from 'clsx'

import { formatPrice } from '@/shared/lib/utils/price/format-price'

import styles from './order-info-item.module.scss'

export type OrderInfoItemProps = {
	title: string
	value: number | string
	big?: boolean
	accent?: boolean
	formatted?: boolean
}

export const OrderInfoItem = ({
	title,
	value,
	big = false,
	accent = false,
	formatted
}: OrderInfoItemProps): JSX.Element => {
	const formattedPrice = typeof value === 'number' ? formatPrice(value) : null

	return (
		<dl
			className={clsx(
				styles.order_info_item,
				big && styles.order_info_item_big,
				accent && styles.order_info_item_accent
			)}>
			<dt className={styles.order_info_item__item_name}>
				<span>{title}</span>
			</dt>

			<dd className={styles.order_info_item__item_value}>
				<span>{formatted ? formattedPrice : value}</span>
			</dd>
		</dl>
	)
}
